import { render, staticRenderFns } from "./ChoiceRadioGroup.vue?vue&type=template&id=d452e69a&scoped=true&"
import script from "./ChoiceRadioGroup.vue?vue&type=script&lang=js&"
export * from "./ChoiceRadioGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d452e69a",
  null
  
)

export default component.exports